import { render, staticRenderFns } from "./MainGoals.vue?vue&type=template&id=73277453"
import script from "./MainGoals.vue?vue&type=script&lang=js"
export * from "./MainGoals.vue?vue&type=script&lang=js"
import style0 from "./MainGoals.vue?vue&type=style&index=0&id=73277453&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports